<ng-container *mobxAutorun>
  <ng-container *ngIf="relativeStorage.has()">
    <!-- Cell used to hold a checkbox that marks the row as selected -->
    <td lf-table-cell *ngIf="allowsRemoval" class="table-cell-select">
      <label
        class="custom-control custom-checkbox"
        (click)="_onLabelClick($event, checkboxElement)"
      >
        <input
          #checkboxElement
          type="checkbox"
          class="custom-control-input"
          [checked]="isSelected"
          (click)="_onSelectionCheckboxClick($event)"
        />
        <span class="custom-control-label"></span>
      </label>
    </td>
    <!-- User defined cells -->
    <ng-content select="th[lf-table-cell], td[lf-table-cell]"></ng-content>
  </ng-container>
</ng-container>
